import { RUBIK_FONT_STACK } from "../../utils/fontStack";

export default function CssBaseline() {
  return {
    MuiCssBaseline: {
      styleOverrides: {
        html: {
          fontFamily: RUBIK_FONT_STACK,
        },
        body: {
          fontFamily: "inherit",
        },
        "#root": {
          fontFamily: "inherit",
        },
      },
    },
  };
}
